import { useLang } from "@/i18n/LanguageContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import BiomarkersSection from "@/components/results/BiomarkersSection";
import AlgorithmsSection from "@/components/results/AlgorithmsSection";
import SupplementsSection from "@/components/results/SupplementsSection";

export default function ResultsDetailTabs({
  biomarkers,
  algorithmResult,
  recommendations,
  onUnlockMore,
}) {
  const { t } = useLang();
  const hasSupplements = recommendations?.topPicks?.length > 0;
  const defaultTab = "clinical";

  return (
    <section className="container-x scroll-mt-24 py-12 md:py-16" data-testid="results-detail-tabs">
      <Tabs defaultValue={defaultTab} className="w-full">
        <TabsList
          className="mb-8 flex h-auto w-full justify-start gap-1 overflow-x-auto rounded-full border border-zinc-200 bg-zinc-50 p-1.5"
          data-testid="results-tabs-list"
        >
          <TabsTrigger
            value="clinical"
            className="shrink-0 rounded-full px-4 py-2.5 text-sm font-semibold text-zinc-600 data-[state=active]:bg-white data-[state=active]:text-[color:var(--sentinel)] data-[state=active]:shadow-sm"
            data-testid="results-tab-clinical"
          >
            {t.results.algorithms.overline}
          </TabsTrigger>
          <TabsTrigger
            value="biomarkers"
            className="shrink-0 rounded-full px-4 py-2.5 text-sm font-semibold text-zinc-600 data-[state=active]:bg-white data-[state=active]:text-[color:var(--sentinel)] data-[state=active]:shadow-sm"
            data-testid="results-tab-biomarkers"
          >
            {t.results.biomarkers.overline}
          </TabsTrigger>
          {hasSupplements && (
            <TabsTrigger
              value="supplements"
              className="shrink-0 rounded-full px-4 py-2.5 text-sm font-semibold text-zinc-600 data-[state=active]:bg-white data-[state=active]:text-[color:var(--sentinel)] data-[state=active]:shadow-sm"
              data-testid="results-tab-supplements"
            >
              {t.results.algorithms.supplementation}
            </TabsTrigger>
          )}
        </TabsList>

        <TabsContent value="clinical" className="mt-0 focus-visible:outline-none focus-visible:ring-0">
          <AlgorithmsSection algorithmResult={algorithmResult} embedded />
        </TabsContent>

        <TabsContent value="biomarkers" className="mt-0 focus-visible:outline-none focus-visible:ring-0">
          <BiomarkersSection biomarkers={biomarkers} embedded />
        </TabsContent>

        {hasSupplements && (
          <TabsContent value="supplements" className="mt-0 focus-visible:outline-none focus-visible:ring-0">
            <SupplementsSection
              recommendations={recommendations}
              onUnlockMore={onUnlockMore}
              embedded
            />
          </TabsContent>
        )}
      </Tabs>
    </section>
  );
}
